import Beer from "./Beer";

export default Beer;